// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pworkEntity from './entities/pwork.json';
import pworkMenu from '../pages/pwork/menu.json';
import pworkFullForm from '../pages/pwork/forms/full.json';
import pworkContextForm from '../pages/pwork/forms/context.json';
import pworkTableView from '../pages/pwork/views/table.json';
import pworkStagesView from '../pages/pwork/views/stages.json';
import pworkCardsView from '../pages/pwork/views/cards.json';
import pworkInlineView from '../pages/pwork/views/inline.json';
import pworkBacklogView from '../pages/pwork/views/backlog.json';
import pworkSplitView from '../pages/pwork/views/split.json';
import pworkCalendarView from '../pages/pwork/views/calendar.json';
import pworkDashboardView from '../pages/pwork/views/dashboard.json';

/** Тип запису «Завдання партії» зі сторінками пакета: меню, форми та подання з pages/pwork/. */
export const pworkDefinition: IRecordTypeDefinition = {
  ...pworkEntity,
  views: assembleViewSet({
      table: pworkTableView,
      stages: pworkStagesView,
      cards: pworkCardsView,
      inline: pworkInlineView,
      backlog: pworkBacklogView,
      split: pworkSplitView,
      calendar: pworkCalendarView,
      dashboard: pworkDashboardView,
  }),
  form: pworkFullForm,
  forms: { full: pworkFullForm, context: pworkContextForm },
  menu: pworkMenu,
} as IRecordTypeDefinition;
